import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetCategories =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.categories.get;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteCategories =
  ({ mediaTypeId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.categories.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaTypeId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageCategories =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let paramID = "";

      if (editMode) {
        paramID = values?.id;
      }
      var bodyData = {};

      if (CheckDataIfExit(values?.name)) {
        bodyData.name = values?.name?.trim();
      }

      const response = await PostFunction({
        data: bodyData,
        Route: editMode
          ? `${UrlApi.categories.edit}/${paramID}`
          : UrlApi.categories.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };
